import { Download, MoreHorizontal, Pencil, Trash2 } from 'lucide-react';
import { datasets as datasetsApi } from '@/api/datasets';
import type { DatasetSummaryDto } from '@/api/types';
import styles from './DatasetActionsMenu.module.css';

interface DatasetActionsMenuProps {
  dataset: DatasetSummaryDto;
  onEdit: () => void;
  onDelete: () => void;
  disabled?: boolean;
  showEdit?: boolean;
}

export function DatasetActionsMenu({ dataset, onEdit, onDelete, disabled = false, showEdit = true }: DatasetActionsMenuProps) {
  const id = dataset.id ?? '';

  return (
    <details className={styles.menu}>
      <summary aria-label={`Actions for ${dataset.displayName ?? 'dataset'}`} aria-disabled={disabled}>
        <MoreHorizontal size={17} />
      </summary>
      <div className={styles.panel}>
        {showEdit && (
          <button type="button" onClick={onEdit} disabled={disabled}>
            <Pencil size={14} /> Edit dataset
          </button>
        )}
        <a href={datasetsApi.candlesFileUrl(id)}>
          <Download size={14} /> Download candles
        </a>
        <a href={datasetsApi.newsFileUrl(id)}>
          <Download size={14} /> Download news
        </a>
        <div className={styles.divider} />
        <button type="button" className={styles.danger} onClick={onDelete} disabled={disabled}>
          <Trash2 size={14} /> Delete dataset
        </button>
      </div>
    </details>
  );
}
